const Kategoriya3312 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
                <h3 className="text-center text-primary">
                    3-sinf 3-chorak<br />
                    Mavzu: Ot, sifat<br />
                    "Oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
                </h3>
                <b>1-mashq. Aralash berilgan so'zlarni ikki guruhga ajrating.</b><br />
                <i>Ta'limiy maqsad:</i> O'quvchilarning morfologik bilimlarini rivojlantirish.<br />
                <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
                Ayiq, gul, qizil, sersuv, uddburon, shirin, mazali, nina, maysa, hosildor, qirmizi, qayrag'och, pushti, hayot, xayol, tafakkur, oriyatli, dono, haqqoniy, ko'klam.<br />
                Savol: bu so'zlarni qaysi belgilariga ko'ra guruhladingiz?<br />
                ______________________________________________________________________________________________________________________________
                <p><b>2-mashq. Guruhlarda ishlang. Ot va sifatlarning lingvistik belgilarini aniqlang.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning morfologik bilimlarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>1-guruh: -li, -dor qo'shimchalari bilan so'zlar hosil qiling. Bu so'zlarning nutqdagi ahamiyatini belgilang.</p>
                <p>2-guruh: -siz, be- qo'shimchalari bilan so'zlar hosil qiling. Bu so'zlarning nutqdagi ahamiyatini belgilang.</p>
                <p>3-guruh: -kor, -chi qo'shimchalari bilan so'zlar hosil qiling. Bu so'zlarning nutqdagi ahamiyatini belgilang.</p>
                <p>3-guruh: -ning, -ni qo'shimchalari bilan so'zlar hosil qiling. Bu so'zlarning nutqdagi ahamiyatini belgilang.</p>
                <p><b>3-mashq. FDM usulidan foydalanib, maqolning ma'nosini izohlang.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning sintaktik bilimlarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Yaxshi so'z qand yedirar,</p>
                <p>Yomon so'z pand yedirar.</p>
                <p>Fikr - ___________________________________________________________</p>
                <p>Dalil - _______________________________________________________</p>
                <p>Misol - __________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3312;